import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IProfile from '@/interfaces/IProfile';
import IUsersGroup from '@/interfaces/IUsersGroup';

import ChooseRole from './ChooseRole/ChooseRole.vue';

@Component({
    name: 'GroupForm',
    components: {
        CardHeader,
        ChooseRole
    }
})
export default class GroupForm extends Vue {
    @Prop(Object) private formData!: IUsersGroup;

    @Action private createUsersGroup!:(form:IUsersGroup) => Promise<void>;

    @Action private updateUsersGroup!:(form:IUsersGroup) => Promise<void>;

    @Getter private profile!:() => IProfile;

    private form:IUsersGroup = this.formData;

    private isEdit: boolean = false;

    private get rootRole() {
        const roles = this.profile().roles;
        if(roles) {
            return  !!roles.find((role:string) => role === 'ROLE_USER')
        }
    }

    private get btnIcon() {
        return !this.isEdit ? 'icon-pencil' : 'icon-lock';
    }

    private get editBtnText() {
        return !this.isEdit ? 'Edit' : 'Lock';
    }

    private get isCreateForm() {
        const expression = this.$route.name === 'users_group_create';
        this.isEdit = expression;
        return expression;
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    private editForm() {
        return (this.isEdit = !this.isEdit);
    }

    private sendForm() {
        const form: IUsersGroup = {
            id: this.form.id,
            name: this.form.name,
            description: this.form.description,
            roles: this.form.roles
        }

        if(this.isCreateForm) {
            this.createUsersGroup(form)
        } else {
            this.updateUsersGroup(form)
        }
    }

    private cancelForm() {
        this.$router.go(-1);
    }

}
